import { render, staticRenderFns } from "./AliyunPlayer.vue?vue&type=template&id=40511b12&scoped=true"
import script from "./AliyunPlayer.vue?vue&type=script&lang=js"
export * from "./AliyunPlayer.vue?vue&type=script&lang=js"
import style0 from "./AliyunPlayer.vue?vue&type=style&index=0&id=40511b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40511b12",
  null
  
)

export default component.exports